// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","goTopButtonWrapper":"_2DFnM","fixed":"_3L0pZ","goTopButton":"_2zr5R","goTopArrow":"_1xkO8"};